import { useAsync } from 'react-use';

import {
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

import { JiraAPIClient } from '../api';
import { JiraIssueSummary } from '../types';

const issueTypeImportance = {
  'In Progress': 3,
  Blocked: 2,
  'To Do': 1,
  Done: 0,
  Backlog: -1,
};
const sortByImportance = (
  issue1: JiraIssueSummary,
  issue2: JiraIssueSummary,
) => {
  return (
    issueTypeImportance[issue2.status as keyof typeof issueTypeImportance] -
    issueTypeImportance[issue1.status as keyof typeof issueTypeImportance]
  );
};

export const useFetchIssues = () => {
  const fetchApi = useApi(fetchApiRef);
  const discoveryApi = useApi(discoveryApiRef);
  const identityApi = useApi(identityApiRef);

  const client = new JiraAPIClient({ fetchApi, discoveryApi, identityApi });

  const {
    value: issues,
    loading,
    error,
  } = useAsync(async () => {
    return await client.fetchIssues();
  });
  if (!issues) {
    return {
      issues: [],
      loading: false,
      error: null,
    };
  }
  const sortedIssues = (issues ?? []).sort(sortByImportance);
  return {
    issues: sortedIssues.filter(
      (issue: JiraIssueSummary) => issue.status !== 'Done',
    ),
    loading,
    error,
  };
};
